import React from 'react';
import './ContainerFront.scss';

import clx from 'classnames';
import { Layout, Space } from 'antd';
import { MainMenu } from '../../routes/menu/MainMenu';
import { ContainerFront } from './ContainerFront';
import { BreadcrumbsContainer } from '../breadcrumb/BreadcrumbsContainer';
import { HeaderFront } from './HeaderFront';
import './FrontLayout.scss';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { FooterFront } from './footer/FooterFront';
import { CookieNotification } from '../cookie/CookieNotification';
import { AdminFrontBanner } from 'client/routes/front/message/AdminFrontBanner';
import { UserNationalityUpdateBanner } from 'client/routes/front/message/UserNationalityAlertBanner';
import { EuNotTrustedUserAlertBanner } from 'client/routes/front/message/EuNotTrustedUserAlertBanner';

export interface FrontLayoutProps {
  children: React.ReactNode;
  isUserPage?: boolean;
  isAdminPreview?: boolean;
}

/**
 * Layout principale dell'applicativo.
 * Contiene la divisione del menu principale, il contenuto e il footer.
 */
export function FrontLayout(props: FrontLayoutProps) {
  const { options } = useThemeConfig();

  return (
    <Layout
      className={clx('front-layout', {
        'user-page': props.isUserPage,
        'has-static-footer': options.showStaticFooter
      })}
    >
      <HeaderFront isAdminPreview={props.isAdminPreview}>
        <MainMenu />
      </HeaderFront>
      <AdminFrontBanner />
      <UserNationalityUpdateBanner />
      <EuNotTrustedUserAlertBanner />
      <ContainerFront isContent>
        <BreadcrumbsContainer isAdminPreview={props.isAdminPreview} />

        {props.children}
      </ContainerFront>
      {options.showStaticFooter && !options.demoVersion && <FooterFront />}
      {options.showCookieBanner && <CookieNotification />}
    </Layout>
  );
}
